import API_SHARED from '@api/shared'
import { isEmpty } from 'lodash'
import COOKIES from '@helpers/cookies'
import { WHATSAPP_MASK_API } from '@api/http-common'
const slugify = require('slugify')

const whatsappParamsCache = {}
const whatsappNumberCache = {}

export const getSubdomain = () => {
  const subdomains = {
    staging: 'staging.cyrela.com.br/apicyrela/api/',
    develop: 'develop.cyrela.com.br/apicyrela/api/',
    localhost: 'localhost:44344/api/',
  }
  const founded = Object.keys(subdomains).find(subdomain =>
    window.location.href.includes(subdomain)
  )

  return subdomains[founded || 'rest']
}

export default {
  emailValid(email) {
    // eslint-disable-next-line
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase())
  },

  fullNameValid(val) {
    let re = /^(.+)\s(.+)$/
    return re.test(String(val))
  },

  phoneValid(phone = '') {
    let re = /^(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9?\s?\d|[2-9])\d{3})-?(\d{4}))$/
    return re.test(String(phone.replaceAll(/-|\s/g, '')))
  },

  cpfValid(cpf) {
    let re = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/
    return re.test(String(cpf))
  },

  cellphoneMask(userInput) {
    let numberLength = 0
    if (userInput) {
      let numbers = userInput.match(/[0-9]/g)
      if (numbers) {
        numberLength = numbers.join('').length
      }
    }

    if (numberLength > 10) {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
    } else {
      return ['(', /[1-9]/, /[1-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]?/]
    }
  },

  cpfMask() {
    return [/[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/]
  },

  unmask(val) {
    let newVal = String(val)
    return newVal.replace(/\D+/g, '')
  },

  unmaskMoney(val) {
    let newVal = String(val)
    return newVal.replace('R$ ', '')
  },

  isMobile() {
    let check = false;
    // eslint-disable-next-line
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check
  },

  messageHelper(mensagem) {
    let page = window.location.pathname.split('/')[1]
    switch (page) {
      case '':
        mensagem += ' - Home'
        break
      case 'sobre-nos':
        mensagem += ' - Sobre nós'
        break
      case 'duvidas-frequentes':
        mensagem += ' - Dúvidas'
        break
      case 'contato':
        mensagem += ' - Contato'
        break
      case 'simulador-cva-mcmv':
        mensagem += ' - Simulador'
        break
      default:
        break
    }
    return mensagem
  },
  slugify(str) {
    if (typeof str === 'string' || str instanceof String) {
      str = str.replace(/&/g, '-')
      str = str.replace(/=/g, '-')
      str = str.replace(/^\//g, '')
      str = str.replace(/\/$/g, '')
      str = str.replace(/\//g, '-')
      return slugify(str, {
        replacement: '-',
        lower: true,
      })
    } else {
      return ''
    }
  },
  getNumbers(str) {
    return str.match(/\d{1,9}/g)
  },
  getCityState(locations, regionId) {
    let resultado = locations.find(item => item.idEstado === regionId)
    return resultado
  },
  calcDistance(lat1, lon1, lat2, lon2) {
    const toRad = val => val * Math.PI / 180

    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)
    const rlat1 = toRad(lat1)
    const rlat2 = toRad(lat2)

    const calc = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(rlat1) * Math.cos(rlat2)
    const distance = 2 * Math.atan2(Math.sqrt(calc), Math.sqrt(1 - calc))
    return distance
  },

  async createWhatsappParams(imovel, region, typeIntegrationLead = 'IdFacilita') {
    // Create a cache key based on the input parameters
    const cacheKey = JSON.stringify(arguments)

    // Check if the result is already in the cache
    if (whatsappParamsCache[cacheKey]) {
      return whatsappParamsCache[cacheKey]
    }

    // Existing function logic
    const SP_REGION_ID = 1
    const gaTags = COOKIES.get('__utmz')
    const gaSend = COOKIES.utmzCookieParse(gaTags)

    const gaCode = COOKIES.get('_ga')
    if (!!gaCode) {
      gaSend.CodigoGa = gaCode
    }

    const msg = 'Olá, gostaria de mais informações sobre '
    let finalMsg = `${msg}${!!imovel && !isEmpty(imovel) ? 'o imóvel' : 'os imóveis da Vivaz.'}`
    const currentPath = window.location.href.split('?')[0]
    const finalPath = currentPath.includes('#') ? currentPath.replace('#', '%23') : currentPath

    let guid = '0'
    if (!!imovel && !isEmpty(imovel)) {
      guid = !!imovel && !!imovel.GuidCrm ? imovel.GuidCrm : '0'

      if (+region === SP_REGION_ID) {
        guid = 0

        if (!!imovel && imovel.IntegraSomenteMobi) {
          if (
            !!imovel && !!imovel[typeIntegrationLead]
          ) {
            guid = imovel[typeIntegrationLead]
          }
        } else {
          if (
            !!imovel && !!imovel.IdFacilita
          ) {
            guid = imovel.IdFacilita
          }
        }
      }
    }

    const params = `?guid=${guid}&utm_source=${gaSend.UtmSource}&utm_medium=${gaSend.UtmMedium}&utm_gclid=${gaSend.UtmGclid}&clientid=${gaSend.CodigoGa}`
    const url = finalPath + params

    if (+region === SP_REGION_ID) {
      const payload = await WHATSAPP_MASK_API.post('', JSON.stringify({ url }))
      const response = payload.data
      finalMsg += `\n\nMeu código de atendimento é ${response.id}.`
    } else {
      finalMsg += `\n\n${url}`
    }

    let result = '&text=' + encodeURIComponent(finalMsg)
    return result
  },

  async createWhatsappUrl({
    event,
    imovel,
    region,
    gaWhatsAppFunction,
    phone,
    typeIntegrationLead,
    pdp,
    idImovel,
  }) {
    let finalTypeIntegrationLead = typeIntegrationLead
    const phoneOnlyNumbers = phone.replace(/\D/g, '')
    let finalPhone = phoneOnlyNumbers

    idImovel = idImovel !== undefined ? idImovel : 0
    const apiNumber = await this.getWhatsappNumberCyrelaApiAsync(region, pdp, idImovel)
    finalPhone = apiNumber === 0 ? finalPhone : apiNumber

    const whatsappParams = await this.createWhatsappParams(
      imovel, region, finalTypeIntegrationLead
    )

    const whatsappUrlRedirect = `https://api.whatsapp.com/send?phone=55${finalPhone}${whatsappParams}`
    gaWhatsAppFunction(event)
    window.open(whatsappUrlRedirect, '_blank', 'noopener,noreferrer')
  },

  async getWhatsappNumberCyrelaApiAsync(region, pdp, idImovel) {
    const cacheKey = JSON.stringify(arguments)

    if (whatsappNumberCache[cacheKey]) {
      return whatsappNumberCache[cacheKey]
    }

    const value = await API_SHARED.getWhatsappNumberCyrelaApi(region, pdp, idImovel).then((response) => {
      return response
    })

    whatsappNumberCache[cacheKey] = value
    return value
  },

  createObjectFromQueryString(queryString) {
    const cleanedQueryString = queryString.startsWith('?') ? queryString.slice(1) : queryString
    return cleanedQueryString.split('&')
      .map(item => item.split('='))
      .reduce((obj, [key, val]) => ({ ...obj, [key]: decodeURIComponent(val) }), {})
  },

  orderedIntegerLists(list, attr = null) {
    if (!!attr) {
      return list.sort((first, second) =>
        first[attr] > second[attr] ? 1 : first[attr] < second[attr] ? -1 : 0
      )
    }
    return list.sort((first, second) =>
      first > second ? 1 : first < second ? -1 : 0
    )
  },
  capitalizeFirstLetter(
    [firstLetter, ...restLetters],
    locale = navigator.language
  ) {
    return `${firstLetter.toLocaleUpperCase(locale)}${restLetters.join('')}`
  },
}




// WEBPACK FOOTER //
// ./src/helpers/tools.js